const {
	base_path,
	base_path_portal,
	base_path_api, 
	base_path_caja,
	base_path_resources,
	anteater_url, 
	gtm_code,
	path_yotpo,
	hidden_discount,
	envio_gratis,
	products_per_pagination,
	stage_dirname,
	api_exception,
	base_path_t1,
	jwt1,
	incodesmile,
	variants
} = window["runConfigCreditSite"]


export const PORTAL_URL = ""
export const BASE_PATH = base_path
export const SUB_DIRECTORY = "credito-claroshop/"
export const BASE_PATH_PORTAL = base_path_portal
export const BASE_PATH_API = base_path_api
export const BASE_PATH_CAJA = base_path_caja
export const BASE_PATH_T1 = base_path_t1
export const BASE_PATH_RESOURCES = base_path_resources

export const BASE_PATH_API_DEV = api_exception
export const STAGE_DIRNAME = stage_dirname
export const VARIANTS_PER_PORTAL = variants
export const JWT1 = jwt1
export const MERCHANT_ID = "decompras"
export const CompanyCode = "076";


export const URL_SERVICIO = `/c/servicio-tecnico/`;
export const GTM_CODE = gtm_code

export const ANTEATER_URL = anteater_url
export const PATH_YOTPO = path_yotpo

export const NO_IMAGE = `${BASE_PATH_RESOURCES}/medios-plazavip/swift/v1/assets/img/noImage.png`

export const MENU_PORTAL =  `${BASE_PATH_API}producto/categoria`

export const SEARCH_ANTEATER = `${ANTEATER_URL}/search`
export const SEARCH_AUTOCOMPLETE = `${ANTEATER_URL}/autocompletar?cliente=sears`
export const STAR_YOTPO = `${PATH_YOTPO}/v1/widget/UmGRN4SZ2WasPZ38vf5bskYT82P9nN4fLYRwxpXD/products`

export const HIDDEN_DISCOUNT = hidden_discount
export const ENVIO_GRATIS = envio_gratis
export const PRODUCTS_PER_PAGINATION = products_per_pagination
export const TIMEOUT_TIME = 25000


export const REACT_APP_USER_SERVER_INCODE = incodesmile